import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { businessTariffsPromoQuotaMobile } from 'reactApp/appHelpers/featuresHelpers/features/businessTariffsPromoQuotaMobile';
import { multiTariffTabPersonalizationVariants } from 'reactApp/appHelpers/featuresHelpers/features/multiTariff';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const queryParams = getQueryParams();

function initTabFallback(initTab) {
    if (initTab === ETabsName.for_work && !businessTariffsPromoQuotaMobile.enabled) {
        return ETabsName.advanced;
    }
    return initTab;
}

const multiTariffMobileInitTabTouch = queryParams?.initTab || getFeature('multi-tariff-mobile-init-tab-touch') || 'advanced';
const multiTariffMobileInitTabAndroid = getFeature('multi-tariff-mobile-init-tab-android') || 'advanced';
const multiTariffMobileInitTabIos = getFeature('multi-tariff-mobile-init-tab') || 'advanced';
const multiTariffWebviewInitTab = IS_IOS_MOBILE ? multiTariffMobileInitTabIos : multiTariffMobileInitTabAndroid;
export const multiTariffMobileInitTab = initTabFallback(IS_WEBVIEW ? multiTariffWebviewInitTab : multiTariffMobileInitTabTouch);

const multiTariffTouchAnonymous: false | 'a' | 'b' | 'c' = IS_MOBILE_BROWSER && getFeature('multi-tariff-touch-show-anonymous');
const multiTariffTouch: false | 'a' | 'b' | 'c' = IS_MOBILE_BROWSER && getFeature('multi-tariff-touch-show');
export const multiTariffTouchRegularOrAnonymous = ANONYM_USER ? multiTariffTouchAnonymous : multiTariffTouch;
const multiTariffWebviewIOS: false | 'a' | 'b' | 'c' = IS_WEBVIEW && getFeature('multi-tariff-ios-show');
const multiTariffWebviewAndroid: false | 'a' | 'b' | 'c' = IS_WEBVIEW && getFeature('multi-tariff-android-show');
export const multiTariffWebview = IS_IOS_MOBILE ? multiTariffWebviewIOS : multiTariffWebviewAndroid;
export const multiTariffMobile = IS_WEBVIEW ? multiTariffWebview : multiTariffTouchRegularOrAnonymous;

/* CLOUDWEB-19477 [Webview And/iOS] Доработки по мультитарифу на вебвью */
const multiTariffWebviewHighlightIOS: boolean = IS_WEBVIEW && isFeature('multi-tariff-ios-highlight');
const multiTariffWebviewHighlightAndroid: boolean = IS_WEBVIEW && isFeature('multi-tariff-android-highlight');
const multitariffHighlightTouch: boolean = IS_MOBILE_BROWSER && isFeature('multi-tariff-touch-highlight');
export const multiTariffHighlightWebview: boolean = IS_IOS_MOBILE ? multiTariffWebviewHighlightIOS : multiTariffWebviewHighlightAndroid;
export const multiTariffHighlightMobile: boolean = IS_WEBVIEW ? multiTariffHighlightWebview : multitariffHighlightTouch;

/* CLOUDWEB-19477 [Webview And/iOS] Вертикальные тарифы в мультитарифе */
const multiTariffWebviewVerticalIOS: boolean = IS_WEBVIEW && isFeature('multi-tariff-ios-vertical');
const multiTariffWebviewVerticalAndroid: boolean = IS_WEBVIEW && isFeature('multi-tariff-android-vertical');
const multiTariffVerticalTouch = IS_MOBILE_BROWSER && isFeature('multi-tariff-touch-vertical');
export const multiTariffVerticalWebview: boolean = IS_IOS_MOBILE ? multiTariffWebviewVerticalIOS : multiTariffWebviewVerticalAndroid;
export const multiTariffVerticalMobile: boolean = IS_WEBVIEW ? multiTariffVerticalWebview : multiTariffVerticalTouch;

/* CLOUDWEB-20022 [Touch] Добавить мультитарифный лендинг на анонимов */
export const multiTariffAnonymousMobile: boolean = IS_MOBILE_BROWSER && isFeature('multi-tariff-anonymous-mobile');

/* https://jira.vk.team/browse/CLOUDWEB-20255 - переключение варианта табов с дефолтного на скроллер */
export const multiTariffsMobileTabsVariant: 'default' | 'scroll' =
    queryParams?.tabVariant || getFeature('multi-tariffs-mobile-tabs-variant') || 'default';

/* https://jira.vk.team/browse/CLOUDWEB-20255 - включение превью анимации табов в скролл режиме*/
export const multiTariffsMobileTabsAnimation =
    multiTariffsMobileTabsVariant === 'scroll' && isFeature('multi-tariffs-mobile-tabs-animation');

// Это для дебага

const BasicTariffsDefaultValue = {
    year: [
        'W1TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W64GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W128GB_1y_lc_blackfriday_2023_discount_single_quota_cloud',
        'W256GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W512GB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W2TB_1y_blackfriday_2023_discount_single_quota_cloud',
        'W4TB_1y_blackfriday_2023_discount_single_quota_cloud',
    ],
    month: [
        'W1T1m_single_quota_2022_cloud',
        'W64G1m_single_quota_2022_cloud',
        'W128G1m_single_quota_2022_cloud',
        'W256G1m_single_quota_2022_cloud',
        'W512G1m_single_quota_2022_cloud',
        'W2T1m_single_quota_2022_cloud',
        'W4T1m_single_quota_2022_cloud',
    ],
};

const BasicAnonymousTariffsDefaultValue = {
    year: [
        'W1TB_1y_minimal_line_with_ads_discount',
        'W64GB_1y_with_ads_discount',
        'W128GB_1y_with_ads_discount',
        'W256GB_1y_minimal_line_with_ads_discount',
        'W512GB_1y_minimal_line_with_ads_discount',
        'W2TB_1y_minimal_line_with_ads_discount',
        'W4TB_1y_minimal_line_with_ads_v2_discount',
    ],
    month: [
        'W1TB_1m_minimal_line_with_ads',
        'W64GB_1m_with_ads',
        'W128GB_1m_with_ads',
        'W256GB_1m_minimal_line_with_ads_v2',
        'W512GB_1m_minimal_line_with_ads',
        'W2TB_1m_minimal_line_with_ads',
        'W4TB_1m_minimal_line_with_ads_v2',
    ],
};

// Тарифы минимальные для анонимов тача.
export const multiTariffBasicTariffListTouchAnonymous =
    getFeature('multi-tariff-basic-tariff-list-touch-anonymous') || BasicAnonymousTariffsDefaultValue;

// Тарифы минимальные для тача.
const multiTariffBasicTariffListTouch = getFeature('multi-tariff-basic-tariff-list-touch') || BasicTariffsDefaultValue;
// Тарифы минимальные для iOS
const multiTariffBasicTariffListIOS = getFeature('multi-tariff-basic-tariff-list-ios') || BasicTariffsDefaultValue;
// Тарифы минимальные для Android
const multiTariffBasicTariffListAndorid = getFeature('multi-tariff-basic-tariff-list-android') || BasicTariffsDefaultValue;
const multiTariffBasicTariffListWebview = IS_IOS_MOBILE ? multiTariffBasicTariffListIOS : multiTariffBasicTariffListAndorid;
export const multiTariffBasicTariffListMobile = IS_WEBVIEW ? multiTariffBasicTariffListWebview : multiTariffBasicTariffListTouch;

const AdvancedAnonymousTariffsDefaultValue = {
    year: [
        'W1TB_1y_landing_segmentation_discount',
        'W256GB_1y_landing_segmentation_discount',
        'W512GB_1y_landing_segmentation_discount',
        'W2TB_1y_landing_segmentation_discount',
        'W4TB_1y_landing_segmentation_discount',
    ],
    month: [
        'W1TB_1m_landing_segmentation_main',
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
        'W4TB_1m_landing_segmentation_main',
    ],
};

const AdvancedTariffsDefaultValue = {
    year: [
        'W1TB_1y_landing_segmentation_discount',
        'W256GB_1y_landing_segmentation_discount',
        'W512GB_1y_landing_segmentation_discount',
        'W2TB_1y_landing_segmentation_discount',
        'W4TB_1y_landing_segmentation_discount',
    ],
    month: [
        'W1TB_1m_landing_segmentation_main',
        'W256GB_1m_landing_segmentation_main',
        'W512GB_1m_landing_segmentation_main',
        'W2TB_1m_landing_segmentation_main',
        'W4TB_1m_landing_segmentation_main',
    ],
};

// Тарифы основные для анонимов тача.
export const multiTariffAdvancedTariffListTouchAnonymous =
    getFeature('multi-tariff-advanced-tariff-list-touch-anonimous') || AdvancedAnonymousTariffsDefaultValue;

const multiTariffAdvancedTariffListTouch = getFeature('multi-tariff-advanced-tariff-list-touch') || AdvancedTariffsDefaultValue;
// Тарифы основные для iOS
const multiTariffAdvancedTariffListIOS = getFeature('multi-tariff-advanced-tariff-list-ios') || AdvancedTariffsDefaultValue;
// Тарифы минимальные для Android
const multiTariffAdvancedTariffListAndorid = getFeature('multi-tariff-advanced-tariff-list-android') || AdvancedTariffsDefaultValue;
const multiTariffAdvancedTariffListWebview = IS_IOS_MOBILE ? multiTariffAdvancedTariffListIOS : multiTariffAdvancedTariffListAndorid;
export const multiTariffAdvancedTariffListMobile = IS_WEBVIEW ? multiTariffAdvancedTariffListWebview : multiTariffAdvancedTariffListTouch;

// Семейные тарифы: две тестовые группы (A — базовые цены, B — годовой -100р)
const FamilyTariffsGroupA = {
    year: [
        'W1TB_1y_family_features_a',
        'W256GB_1y_family_features_discount',
        'W512GB_1y_family_features_discount',
        'W2TB_1y_family_features_discount',
        'W4TB_1y_family_features_discount',
    ],
    month: [
        'W1TB_1m_family_features_mobile_a',
        'W256GB_1m_family_features_mobile_a',
        'W512GB_1m_family_features_mobile_a',
        'W2TB_1m_family_features_mobile_a',
        'W4TB_1m_family_features_mobile_a',
    ],
};

const FamilyTariffsGroupB = {
    year: [
        'W1TB_1y_family_as_option_discount',
        'W256GB_1y_family_as_option_discount',
        'W512GB_1y_family_as_option_discount',
        'W2TB_1y_family_as_option_discount',
        'W4TB_1y_family_features_discount', // нет -100р, берём обычный
    ],
    month: [
        'W1TB_1m_family_as_option_discount_3m',
        'W256GB_1m_family_as_option_discount_3m',
        'W512GB_1m_family_as_option_discount_3m',
        'W2TB_1m_family_as_option_discount_3m',
        'W4TB_1m_family_features_mobile_a',
    ],
};

const FamilyAnonimousTariffs = {
    year: [
        'W1TB_1y_family_features_a',
        'W256GB_1y_family_features_discount',
        'W512GB_1y_family_features_discount',
        'W2TB_1y_family_features_discount',
        'W4TB_1y_family_features_discount',
    ],
    month: [
        'W1TB_1m_family_features_mobile_a',
        'W256GB_1m_family_features_mobile_a',
        'W512GB_1m_family_features_mobile_a',
        'W2TB_1m_family_features_mobile_a',
        'W4TB_1m_family_features_mobile_a',
    ],
};

// Фичи платформенные для включения семейности как опции
export const familyByOptionsFeatureMobileIOS = IS_IOS_MOBILE && isFeature('family-by-options-feature-mobile-ios');
export const familyByOptionsFeatureMobileAndroid = !IS_IOS_MOBILE && isFeature('family-by-options-feature-mobile-android');
export const familyByOptionsFeatureMobile = Boolean((familyByOptionsFeatureMobileIOS || familyByOptionsFeatureMobileAndroid) && IS_WEBVIEW);

// Фича автотултипа, платформенная
export const familyByOptionsEnterTooltipFeatureMobileIOS = IS_IOS_MOBILE && isFeature('family-by-options-enter-tooltip-mobile-ios');
export const familyByOptionsEnterTooltipFeatureMobileAndroid =
    !IS_IOS_MOBILE && isFeature('family-by-options-enter-tooltip-mobile-android');
export const familyByOptionsEnterTooltipFeatureMobile = Boolean(
    (familyByOptionsEnterTooltipFeatureMobileIOS || familyByOptionsEnterTooltipFeatureMobileAndroid) && IS_WEBVIEW
);

const familySkuGroupBEnabled: boolean = isFeature('family-by-options-feature-mobile-group-b');

// Тарифы семейные для анонимов тача.
export const multiTariffFamilyTariffListTouchAnonymous =
    getFeature('multi-tariff-family-tariff-list-touch-anonimous') || FamilyAnonimousTariffs;

export const multiTariffFamilyTariffListMobile =
    getFeature('multi-tariff-family-tariff-list-mobile') || (familySkuGroupBEnabled ? FamilyTariffsGroupB : FamilyTariffsGroupA);

if (IS_MOBILE_BROWSER || IS_WEBVIEW) {
    registerExperiment('multitariff-mobile', multiTariffMobile, [
        AnalyticEventNames.MOBILE_LANDING_SHOWN,
        AnalyticEventNames.QUOTA_LANDING_SHOWN,
        AnalyticEventNames.MULTITARIFF_TYPE_CLICK_M,
        AnalyticEventNames.MULTITARIFF_SIZE_CLICK_M,
        AnalyticEventNames.TARIFF_CLICK,
    ]);
}

/** CLOUD-20115: Фича для скрытия переключателя смены периода тарифа на таче */
export const multiTariffHidePeriodSwitchTouch: boolean = isFeature('multi-tariff-hide-period-switch-touch');

const multiTariffHidePeriodSwitchIOS: boolean = isFeature('multi-tariff-hide-period-switch-ios');
const multiTariffHidePeriodSwitchAndroid: boolean = isFeature('multi-tariff-hide-period-switch-android');

/** CLOUD-20115: Фича для скрытия переключателя смены периода тарифа на вебвью */
export const multiTariffHidePeriodSwitchWebview: boolean = IS_IOS_MOBILE
    ? multiTariffHidePeriodSwitchIOS
    : multiTariffHidePeriodSwitchAndroid;

const periodSwitchShowWebview = !multiTariffHidePeriodSwitchWebview && IS_WEBVIEW;
const periodSwitchShowTouch = !multiTariffHidePeriodSwitchTouch && IS_MOBILE_BROWSER && !IS_WEBVIEW;
export const periodSwitchShowWebviewOrTouch = periodSwitchShowWebview || periodSwitchShowTouch;

export const multiTariffTabPersonalizationTouch: multiTariffTabPersonalizationVariants =
    getFeature('multi-tariff-tab-personalization-touch') || multiTariffTabPersonalizationVariants.year;
export const multiTariffTabPersonalizationWebview: multiTariffTabPersonalizationVariants =
    getFeature('multi-tariff-tab-personalization-webview') || multiTariffTabPersonalizationVariants.year;

export const isMultiTariffTabPersonalizationTouchOnlyMonth: boolean =
    multiTariffTabPersonalizationTouch === multiTariffTabPersonalizationVariants.onlyMonth;
export const isMultiTariffTabPersonalizationWebviewOnlyMonth: boolean =
    multiTariffTabPersonalizationWebview === multiTariffTabPersonalizationVariants.onlyMonth;
export const multiTariffShowTabsMobile: boolean =
    (IS_MOBILE_BROWSER && !IS_WEBVIEW && isMultiTariffTabPersonalizationTouchOnlyMonth) ||
    (IS_WEBVIEW && isMultiTariffTabPersonalizationWebviewOnlyMonth);
